import React, { HTMLInputTypeAttribute } from 'react'
import clsx from 'clsx'
import { FieldHookConfig, useField, useFormikContext } from 'formik'
import { SizeVariants } from '@/shared/forms/components/constants'
import Markdown from 'react-markdown'

export type Option = {
  id: string
  label: string
}

export type FormikInputProps = {
  label: string
  size: keyof typeof SizeVariants
  autocomplete: string
  options: Option[]
  disabled?: boolean
  placeholder?: string
  optional?: boolean
  type?: HTMLInputTypeAttribute
} & FieldHookConfig<string>

export default function FormikCheckbox({
  label,
  size,
  options,
  autocomplete,
  disabled,
  placeholder,

  optional = false,
  ...props
}: FormikInputProps) {
  const [field, meta] = useField(props)
  const { isSubmitting } = useFormikContext()
  const isDisabled = disabled || isSubmitting
  const typedOptions = options as Option[]

  return (
    <div className={SizeVariants[size as keyof typeof SizeVariants]}>
      <div className="flex justify-between">
        <label
          htmlFor={props.name}
          className={clsx(
            'block text-sm font-medium leading-6',
            isDisabled ? 'text-gray-500' : 'text-gray-900',
          )}
        >
          <Markdown>{label}</Markdown>
        </label>
        {optional && (
          <span className="text-sm leading-6 text-gray-500" id="email-optional">
            Optional
          </span>
        )}
      </div>
      <div className="mt-2 space-y-3">
        {typedOptions.map(({ id, label }) => (
          <div
            key={`${props.name}-${id}`}
            className="flex items-center gap-x-3"
          >
            <input
              id={`${props.name}-${id}`}
              name={props.name}
              type="checkbox"
              className={clsx(
                'h-4 w-4 border-gray-300 focus:ring-blue-600',
                isDisabled ? 'text-slate-300' : 'text-blue-600',
              )}
              value={id}
              onChange={field.onChange}
              onBlur={field.onBlur}
              disabled={isDisabled}
              checked={field.value ? field.value.includes(id) : false}
            />
            <label
              htmlFor={`${props.name}-${id}`}
              className={clsx(
                'block text-sm font-medium leading-6',
                isDisabled ? 'text-gray-500' : 'text-gray-900',
              )}
            >
              {label}
            </label>
          </div>
        ))}
        {meta.touched && meta.error && (
          <div className="mt-2 text-sm font-semibold text-red-600">
            {meta.error}
          </div>
        )}
      </div>
    </div>
  )
}
